import api from "./api";

const VisaService = {
  async listProducts(region) {
    const r = await api.get("/visas/products", { params: { region } });
    return r.data;
  },
  async getProductBySlug(slug) {
    const r = await api.get(`/visas/products/${slug}`);
    return r.data;
  },
  async getRequirement(from, to) {
    const r = await api.get(`/visas/requirements/${from}/${to}`);
    return r.data;
  },
  async listOffices(state, city) {
    const r = await api.get("/visas/offices", { params: { state, city } });
    return r.data;
  },
  async listEmbassies(country, city) {
    const r = await api.get("/visas/embassies", { params: { country, city } });
    return r.data;
  },
  async listForms(country) {
    const r = await api.get("/visas/forms", { params: { country } });
    return r.data;
  },
  async listPassportCountries() {
    const r = await api.get("/visas/countries/passport");
    return r.data;
  },
  async listDestinationCountries() {
    const r = await api.get("/visas/countries/destination");
    return r.data;
  },
};

export default VisaService;
